import axios from 'axios'

export const addRoomBooking = async (data, token) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/room/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error adding ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to add ticket room. Please try again.')
            // return []
        }
    }
};

export const getRoomBookings = async (token) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/room/all`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data.data;
    } catch (error) {
        console.error('Error getting ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to add ticket room. Please try again.')
            // return []
        }
    }
};

export const getRoomBookingsByRoomBookigID = async (id, token) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/room/booking/booking/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data.data;
    } catch (error) {
        console.error('Error getting ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to add ticket room. Please try again.')
            // return []
        }
    }
};

export const getRoomBookingsByDate = async (date, token) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/room/booking/date/${date}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data.data;
    } catch (error) {
        console.error('Error getting ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to add ticket room. Please try again.')
            // return []
        }
    }
};

export const getRoomBookingsByBetweenDate = async (data, token) => {
    try {
        // console.log('Getting Room Bookings',data);
        const res = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/room/booking/between/date`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data.data;
    } catch (error) {
        console.error('Error getting ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to add ticket room. Please try again.')
            // return []
        }
    }
};

export const updateRoomBooking = async (id, data, token) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/room/update/booking/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating ticket room:', error);
        if (error.response) {
            throw new Error(`Failed to update ticket room: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to update ticket room. Please try again.')
            // return []
        }
    }
}

export const getSummaryRoomBooking = async (token) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/room/summary`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data;
    } catch (error) {
        console.error('Error getting summary:', error);
        if (error.response) {
            throw new Error(`Failed to get summary: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to get summary. Please try again.')
            // return []
        }
    }
}

export const getSummaryRoomBookingToday = async (token) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/room/summary/today`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        })
        return res.data;
    } catch (error) {
        console.error('Error getting summary:', error);
        if (error.response) {
            throw new Error(`Failed to get summary: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to get summary. Please try again.')
            // return []
        }
    }
}

export const SearchingRoomBooking = async (data, token) => {
    try {
        const res = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/room/booking/search`, data, {
            headers: {
                'Content-Type': 'application/json',
                "ngrok-skip-browser-warning": "true",
                'Authorization': `Bearer ${token}`,
            },
        })
        return res.data;
    } catch (error) {
        console.error('Error searching room booking:', error);
        if (error.response) {
            throw new Error(`Failed to search room booking: ${error.response.data.message || 'Unknown error'}`)

        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
            // return []
        } else {
            throw new Error('Failed to search room booking. Please try again.')
            // return []
        }
    }
}

export const DownloadExcelDataRoomBooking = async (data, token) => {
    try {
        // ส่งคำขอ GET ไปยัง backend เพื่อดาวน์โหลดไฟล์ Excel
        const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/room/booking/excel`, { data: data }, {
            responseType: 'blob', // กำหนดให้รับข้อมูลเป็น Blob ซึ่งเป็นรูปแบบไฟล์
        });

        // ตรวจสอบว่าการตอบกลับสำเร็จหรือไม่
        if (response.status === 200) {
            // สร้าง URL สำหรับ Blob ที่ได้รับ
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // สร้าง <a> tag สำหรับดาวน์โหลดไฟล์
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'room_bookings.xlsx'); // ตั้งชื่อไฟล์ที่ดาวน์โหลด
            document.body.appendChild(link);
            link.click(); // ทำการคลิกที่ลิงก์เพื่อดาวน์โหลด
            document.body.removeChild(link); // ลบ <a> tag ออกหลังจากดาวน์โหลดเสร็จ
            window.URL.revokeObjectURL(url); // ลบ URL ที่สร้างขึ้น
        }
    } catch (error) {
        console.error('Error downloading Excel:', error);
    }
};

export const ContractPDFRoom = async (data,token) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_HOST_PATH}/api/room/booking/contract/pdf`,
            data,
            { 
                responseType: 'blob' ,  // รับข้อมูลเป็น Blob
                headers: {
                    Authorization: `Bearer ${token}`, // เพิ่ม Authorization Header
                    'Content-Type': 'application/json', // ตัวอย่าง header อื่นๆ
                },
            } // รับข้อมูลเป็น Blob
        );

        // ตรวจสอบสถานะคำขอ
        if (response.status === 200) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // สร้างลิงก์สำหรับดาวน์โหลด
            const link = document.createElement('a');
            link.href = url;
            link.download = 'contract.pdf'; // ชื่อไฟล์ PDF ที่จะดาวน์โหลด
            document.body.appendChild(link); // เพิ่มลิงก์เข้าไปใน DOM ชั่วคราว
            link.click(); // จำลองการคลิกเพื่อดาวน์โหลดไฟล์
            document.body.removeChild(link); // ลบลิงก์ออกจาก DOM

            // ลบ URL ชั่วคราว
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 1000);
        } else {
            console.error("Failed to fetch PDF, Status:", response.status);
            alert(`Failed to generate PDF. Status: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching PDF:", error);
        alert("An error occurred while generating the PDF. Please try again.");
    }
};

export const ContractEmailRoom = async (data,token) => {
    try{
        const response = await axios.post(
            `${process.env.REACT_APP_HOST_PATH}/api/room/booking/contract/email`,
            data,// ส่งข้อมูลเพิ่มเติมหากจำเป็น
            {
                headers: {
                    Authorization: `Bearer ${token}`, // เพิ่ม Authorization Header
                    'Content-Type': 'application/json', // ตัวอย่าง header อื่นๆ
                },
            }
        )
    }catch(error){
        console.error("Error fetching PDF:", error);
    }
}

